import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-delete',
	path: '/secure/admin/DeleteFieldLayout!default.jspa',
};
